import { Controller } from 'stimulus'

export default class LinkSelectController extends Controller {
  optionChange() {
    const selectedOption = $(this.element).find(':selected')[0]

    SecuricyApp.window.location = selectedOption.dataset.url
  }
}
